import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import ContentSection from "./components/ContentSection";
import ComparisonSection from "./components/ComparisonSection";
import ArticlesSection from "./components/ArticlesSection";
import FAQSection from "./components/FAQSection";

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://vigorbuyspread.us";

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Vigorbuy Spreadsheet",
    "url": siteUrl,
    "description": "The ultimate product discovery platform. Explore organized product databases, category guides, QC photo resources, shopping tutorials, and expert recommendations for smarter shopping.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${siteUrl}/search?q={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Vigorbuy Spreadsheet",
    "url": siteUrl,
    "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg",
    "description": "The ultimate product discovery platform for smarter shopping with organized spreadsheet databases across 14 product categories.",
    "sameAs": [
      "https://kaspreadsheet.com"
    ]
  };

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <ContentSection />
        <ComparisonSection />
        <ArticlesSection />
        <FAQSection />
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-4">
              Ready to Start Shopping Smarter?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto mb-8">
              Explore the Vigorbuy Spreadsheet today and discover a better way to find products across 14+ categories.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 font-semibold text-sm rounded-full hover:bg-accent-600 transition-all duration-300 whitespace-nowrap"
              >
                Vigorbuy Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
    </>
  );
}